import { ButtonTheme } from '@/components/Button/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Button = GenericSlot({ as: 'button', theme: ButtonTheme });
